import React from 'react';
import PageTitle from 'components/common/PageTitle';
import s from './LegalPage.module.scss';

export const ExternalLink = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

export const LegalSection = ({ title, children }) => (
  <section className={s.section}>
    {title ? <h2>{title}</h2> : null}
    {children}
  </section>
);

export const LegalList = ({ children, ordered = false, start }) => {
  const List = ordered ? 'ol' : 'ul';

  return (
    <List className={s.list} start={ordered ? start : undefined}>
      {children}
    </List>
  );
};

export const LegalListItem = ({ children, emphasized }) => (
  <li className={emphasized ? s.emphasized : undefined}>{children}</li>
);

export default function LegalPage({ title, children }) {
  return (
    <article className={s.page}>
      <PageTitle auth>{title}</PageTitle>
      {children}
    </article>
  );
}
